import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { AiOutlineAmazon } from 'react-icons/ai';
import { SiEbay } from 'react-icons/si'
import { TbBrandWalmart } from 'react-icons/tb'
import { View, Text, StyleSheet, TouchableOpacity, Button, Linking } from 'react-native';

const MarketWidget = ({ iconname, text, link }) => {

    return (
        <TouchableOpacity style={styles.container} onPress={() => Linking.openURL(link)}>
            <View style={{ marginRight: '30px', marginLeft: '10px' }}>{iconname}</View>
            <Text>{text}</Text>
        </TouchableOpacity>
    )
}

const Market = ({navigation}) => {
    
    return (
        <View style={styles.pagewrap}>
            <View style={styles.page}>
                <View style={{ width: '20%', maxWidth: '100px' }}>
                    <Button title='Home' color="black" onPress={() => navigation.navigate('Home')}>

                    </Button>
                </View>
                <View style={styles.wrapper}>
                    <MarketWidget iconname={<AiOutlineAmazon fontSize="3em" />} text={'Find us on Amazon!'} link={'https://www.amazon.com/stores/AmericanBubbleBoy/page/1A527272-DA53-4764-A45A-A7AC57185819?maas=maas_adg_0C424E062943B0EDB1CAE38804998BEF_afap_abs&ref_=aa_maas&tag=maas'} />
                    <MarketWidget iconname={<TbBrandWalmart fontSize="3em"/>} text={'Look for us on Walmart!'} link={'https://www.walmart.com/search?q=American+Bubble+Boy'} />
                    <MarketWidget iconname={<SiEbay fontSize="3em"/>} text={'Check us out on ebay!'} link={'https://www.ebay.com/sch/i.html?_from=R40&_trksid=p2380057.m570.l1313&_nkw=American+Bubble+Boy&_sacat=0'} />
                </View>
            </View>
           
        </View>
    )
}

const styles = StyleSheet.create({
    pagewrap: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '90vh',
        maxHeight: '90vh',
        backgroundColor: 'white'
    },
    page:{
        width: '100%',
        maxWidth: '900px',
        height: '100%',
        maxHeight: '100%',
        backgroundColor: 'white'
    },
    wrapper: {
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white'
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '75%',
        height: '15%',
        border: '1px solid black',
        marginBottom: '50px',
        maxWidth: '400px'
    },
})

export default Market;